/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

const AppConstants = {
  OK_STATUS : "OK",
  ERROR_STATUS : "ERROR",
  
  ROLE_ADMIN       : "ADMIN",
  ROLE_DEALER      : "DEALER",
  ROLE_TECH_SUP    : "TECHSUPPORT",


  USER_LOGIN       : 'USER_LOGIN',
  USER_LOGIN_ERROR : 'USER_LOGIN_ERROR',
  USER_LOGOUT      : 'USER_LOGOUT',
  USER_CREATED     : 'USER_CREATED',
  USER_CONFIRMED   : 'USER_CONFIRMED',

  PRODUCT_SET_LOAD      : 'PRODUCT_SET_LOAD',
  PRODUCT_LOAD          : 'PRODUCT_LOAD',
  PRODUCT_SAVE          : 'PRODUCT_SAVE',
  PRODUCT_SET_LOAD_ERR  : 'PRODUCT_SET_LOAD_ERR',
  PRODUCT_LOAD_ERR      : 'PRODUCT_LOAD_ERR',
  PRODUCT_SAVE_ERR      : 'PRODUCT_SAVE_ERR',

  SEARCH_JOBS           : 'SEARCH_JOBS',
  SEARCH_JOBS_ERR       : 'SEARCH_JOBS_ERR',
  SAVE_JOB              : 'SAVE_JOB',
  SAVE_JOB_ERR          : 'SAVE_JOB_ERR',
  DELETE_JOB            : 'DELETE_JOB',
  DELETE_JOB_ERR        : 'DELETE_JOB_ERR',
  LOAD_JOB              : "LOAD_JOB",
  LOAD_JOB_ERR          : "LOAD_JOB_ERR",

  ALL_USERS             : 'ALL_USERS',
  ALL_USERS_ERR         : 'ALL_USERS_ERR',
  USER_BY_EMAIL         : 'USER_BY_EMAIL',
  USER_BY_EMAIL_ERR     : 'USER_BY_EMAIL_ERR',
  SAVE_USER             : 'SAVE_USER',
  SAVE_USER_ERR         : 'SAVE_USER_ERR',

  ALL_DEALER_USERS      : 'ALL_DEALER_USERS',
  ALL_DEALER_USERS_ERR  : 'ALL_DEALER_USERS_ERR',
  ALL_DEALERS           : 'ALL_DEALERS',
  ALL_DEALERS_ERR       : 'ALL_DEALERS_ERR',
  DELETE_DEALER         : 'DELETE_DEALER',
  DELETE_DEALER_ERR     : 'DELETE_DEALER_ERR',
  SAVE_DEALER           : 'SAVE_DEALER',
  SAVE_DEALER_ERR       : 'SAVE_DEALER_ERR',

  JOB_IMAGE_SAVE        : 'JOB_IMAGE_SAVE',
  JOB_IMAGE_SAVE_ERR    : 'JOB_IMAGE_SAVE_ERR',

  GET_JOB_HISTORY       : 'GET_JOB_HISTORY',
  GET_JOB_HISTORY_DAY   : 'GET_JOB_HISTORY_DAY',
  GET_JOB_HISTORY_SUMMARY   : 'GET_JOB_HISTORY_SUMMARY',
  GET_JOB_HISTORY_ERR   : 'GET_JOB_HISTORY_ERR'
};


export default AppConstants ;




// WEBPACK FOOTER //
// ./src/app/constants/AppConstants.js